import React, { useEffect } from 'react'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import { isAdminAuthenticated } from '../services/authService';
import Sidebar from './sidebar'
import Header from './header'

function AdminLayout() {
  const location = useLocation();
  const navigate = useNavigate();
  const hideLayoutPages = ['/admin/login', '/admin/forgotPassword'];
  const shouldHideLayout = hideLayoutPages.includes(location.pathname);

  useEffect(() => {
    if (!shouldHideLayout && !isAdminAuthenticated()) {
      navigate('/admin/login');
    }
  }, [location.pathname, shouldHideLayout, navigate]);

  useEffect(() => {
  
    const loadAdminCSS = () => {
      
      const bootstrapLink = document.createElement('link');
      bootstrapLink.rel = 'stylesheet';
      bootstrapLink.href = `${process.env.PUBLIC_URL}/admin/css/bootstrap.min.css`;
      document.head.appendChild(bootstrapLink);

      const styleLink = document.createElement('link');
      styleLink.rel = 'stylesheet';
      styleLink.href = `${process.env.PUBLIC_URL}/admin/css/style.css`;
      document.head.appendChild(styleLink);

      return { bootstrapLink, styleLink };
    };

    const cssLinks = loadAdminCSS();

    return () => {
      if (cssLinks.bootstrapLink && document.head.contains(cssLinks.bootstrapLink)) {
        document.head.removeChild(cssLinks.bootstrapLink);
      }
      if (cssLinks.styleLink && document.head.contains(cssLinks.styleLink)) {
        document.head.removeChild(cssLinks.styleLink);
      }
    };
  }, []);

  return (
    <div className="admin-layout">
        {!shouldHideLayout && <Sidebar />}
      {!shouldHideLayout && <Header />}
      <Outlet />
      
    </div>
  )
}

export default AdminLayout